export { default } from "./PowerWordSummaryInfo";
